export default class CreateRateSourceRequest {
    code: string = '';
    description: string = '';
}
